import { UserService } from 'src/app/angularJS/services/user/user.service';
import { LinkBuilder } from 'src/app/angularJS/services/link-builder.service';
import { QueryBuilder } from 'src/app/angularJS/services/query-builder.service';

export class SchemaFormExternalResourceSelectorController {
  public static $inject = [
    '$scope',
    '$injector',
    'schemaFieldsThatNeedSpecialControls',
    'serviceEndpointToServiceNameDictionary',
    'userService',
    'LinkBuilder',
    'QueryBuilder',
    '$q'
  ];
  public ngModel: any;
  public resources: Array<any> = [];
  public selectedResource: any;
  public fieldDetails: InterACT.Interfaces.ISpecialSchemaFieldDetails;

  constructor(
    private $scope,
    private $injector: ng.auto.IInjectorService,
    private schemaFieldsThatNeedSpecialControls: Array<InterACT.Interfaces.ISpecialSchemaFieldDetails>,
    private serviceEndpointToServiceNameDictionary: InterACT.Interfaces.IDictionary<string>,
    private userService: UserService,
    private linkBuilder: LinkBuilder,
    private queryBuilder: QueryBuilder,
    private $q: ng.IQService) {
    // tslint:disable-next-line: forin
    for (const propertyName in $scope.vm) {
      this[propertyName] = $scope.vm[propertyName];
    }

    this.activate();
  }

  /**
   * A method that handles the event where the selected resource has changed
   */
  public onChanged() {
    if (this.selectedResource.id === undefined && ('search-results' === this.fieldDetails.endpoint && !this.selectedResource.link)) {
      //TODO: MORE WORK TO BE DONE HERE. HOW DO WE KNOW WHAT PROPERTY TO SET ON THE ITEM
      //AND ALSO HOW DO WE KNOW WHAT TO SET IT TO?
      //THE BELOW EXAMPLE ONLY WORKS FOR TRANSPORT OPERATOR LINKS
      //this.$scope.$parent.$parent.item.name = this.selectedResource.name.en;
      this.ngModel[0].$setViewValue(undefined);
      this.ngModel[0].$commitViewValue();
      return;
    }

    // For catalogue items, we need to get the catalogue item link a little differently
    const newValue = 'search-results' === this.fieldDetails.endpoint
      ? this.selectedResource.link.split('?').shift()
      : `/${this.fieldDetails.endpoint}/` + this.selectedResource.id;

    if (this.ngModel[0].$viewValue !== newValue) {
      //TODO: MORE WORK TO BE DONE HERE. HOW DO WE KNOW WHAT PROPERTY TO SET ON THE ITEM
      //AND ALSO HOW DO WE KNOW WHAT TO SET IT TO?
      //THE BELOW EXAMPLE ONLY WORKS FOR TRANSPORT OPERATOR LINKS
      //this.$scope.$parent.$parent.item.name = this.selectedResource.name.en;
      this.ngModel[0].$setViewValue(newValue);
      this.ngModel[0].$commitViewValue();
    }
  }

  /**
   * A method that returns a display name for the supplied resource
   * @param resource the resource to get the display name for
   */
  public getDisplayName = (resource: any) => {
    return this.fieldDetails.getDisplayName(resource);
  };

  /**
   * A method that determines if the supplied resource is selected or not in the dropdown
   * @param resource the resource to check the selection state of
   */
  public isResourceSelected = (resource) => {
    return 'search-results' === this.fieldDetails.endpoint
      ? this.selectedResource && resource.link === this.selectedResource.link
      : this.selectedResource && resource.id === this.selectedResource.id;
  };

  /**
   * A method that is called during controller instantiation
   */
  public activate() {
    const filteredListOfSchemaFields = this.schemaFieldsThatNeedSpecialControls.filter((schemaFieldData) => {
      return schemaFieldData.name === this.$scope.form.title;
    });

    if (filteredListOfSchemaFields.length === 0) {
      throw new Error('No matching resource details found for ' + this.$scope.form.title);
    }

    this.fieldDetails = filteredListOfSchemaFields[0];
    this.populateDropdownItems().then(() => {
      this.setSelectedItemFromModel();
    });
  }

  /**
   * A method that sets the selected item dropdown item based on the value in the model
   */
  private setSelectedItemFromModel() {
    if (!this.ngModel || this.ngModel.length === 0 || this.ngModel[0].$$rawModelValue.length === 0) {
      return;
    }

    // Search result resources do not have an ID field, only a link, so we need a special case for these.

    let resourceIdFromModel = 'search-results' === this.fieldDetails.endpoint
      ? this.ngModel[0].$$rawModelValue
      : this.ngModel[0].$$rawModelValue.split('/').pop();

    let filteredListOfResources = [];

    this.resources.forEach(resource => {
      if (resource.id && resource.id == resourceIdFromModel) {
        filteredListOfResources.push(resource);
      } else if (resource.link && resource.link.split('?').shift() == resourceIdFromModel) {
        filteredListOfResources.push(resource);
      }
    });

    if (filteredListOfResources.length === 0) {
      return;
    }

    this.selectedResource = filteredListOfResources[0];
  }

  /**
   * A method that retrieves resources from the appropriate service and populates the dropdown options with those resources
   */
  private populateDropdownItems() {
    const deferred = this.$q.defer();

    if (!this.fieldDetails) {
      this.resources = [];
      deferred.resolve();
      return;
    }

    const serviceName = this.serviceEndpointToServiceNameDictionary[this.fieldDetails.endpoint];
    const service: any = this.$injector.get(serviceName);
    const schemeLink = this.linkBuilder.getSchemesLink(this.userService.selectedScheme.id);
    const globalSchemeLink = '/globalScheme';

    const queryBuilder = this.queryBuilder
      .newParam()
      .openSubQuery()
      .fieldIs('scheme.link', schemeLink)
      .or()
      .fieldIs('schemes.link', schemeLink)
      .or()
      .fieldIs('scheme.link', globalSchemeLink)
      .or()
      .fieldIs('schemes.link', globalSchemeLink)
      .closeSubQuery();

    if (this.fieldDetails.buildAdditionalQuery) {
      this.fieldDetails.buildAdditionalQuery(queryBuilder);
    }

    const query = queryBuilder
      .sortBy([{
        columnName: this.fieldDetails.displayNamePath,
        direction: 'asc'
      }])
      .getParam();

    service.getList(1, 1000, query).then((response) => {
      if (response instanceof Array) {
        this.resources = response;
        deferred.resolve();
        return;
      }

      const resourceList = response[this.fieldDetails.responseFieldThatContainsResources];

      if (resourceList.length === 0) {
        this.resources = [];
        deferred.resolve();
        return;
      }

      if (resourceList[0].meta) {
        this.resources = resourceList.map((resourceWithMeta) => {
          return resourceWithMeta[this.fieldDetails.responseFieldThatContainsIndividualResource];
        });
      } else {
        this.resources = resourceList;
      }

      deferred.resolve();
    });

    return deferred.promise;
  }
}